import React from "react";
import { GoArrowDown } from "react-icons/go";
import { FaEyeSlash, FaFileAlt } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { PiSquareLogoFill } from "react-icons/pi";
import Links from "../sub-components/Links";
const { PUBLIC_URL } = process.env;

const Feature7 = () => {

  const dashboard_Video = process.env.REACT_APP_DASHBOARD_VIDEO;

  return (
    <div>
      <section className="section main-banner" id="f7top">
        <video autoPlay muted loop id="bg-video">
          <source
            src={dashboard_Video}
            type="video/mp4"
          />
        </video>

        <div className="video-overlay header-text">
          <div className="caption">
            <h4 style={{ color: "#f5a425" }}>
              Full security with advanced technology
            </h4>
            <h6>
              When it comes to the security of your
              <br /> online data there can be no compromise.
            </h6>

            <div className="main-button">
              <div className="scroll-to-section">
                <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
              </div>
            </div>
            <br />
            <div>
              <p style={{ fontSize: "16px", color: "white" }}>Learn more</p>
              <GoArrowDown style={{ color: "white" }} />
            </div>
          </div>
        </div>
      </section>

      <section className="dark-bg2">
        <div className="container-fluid dark-bg-sec">
          <div className="row f7sec1">
            <div className="col-lg-12 f7sec1head">
              <h4>Exclusive ownership</h4>
              <h2>
                All NexTestify-based data is owned by you, the user,
                <br />
                exclusively. We do not have any access to or right to use your
                content.{" "}
              </h2>
            </div>

            <div className="col-lg-4 f7sec1content">
              <div>
                <FaEyeSlash className="f7sec1contentIcon" />
              </div>

              <h3>GDPR ready</h3>
              <p>
                We offer a customized data processing agreement that covers all
                bases and is linked to our Terms and Conditions.
              </p>
            </div>

            <div className="col-lg-4 f7sec1content">
              <div>
                <FaFileAlt className="f7sec1contentIcon" />
              </div>
              <h3>Data security</h3>
              <p>
                All NexTestify plans offer the highest level of security for
                your results and other personal data.
              </p>
            </div>
            <div className="col-lg-4 f7sec1content">
              <div>
                <IoMdLock className="f7sec1contentIcon" />
              </div>

              <h3>Descriptive open-ended questions</h3>
              <p>
                Open-ended questions test respondents’ ability to provide
                complex answers. These must be reviewed manually by the test
                owner.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="img-bg">
        <div className="container-fluid img-bg-sec">
          <div className="row f7sec2">
            <div className="col-md-12 col-lg-6  f7sec2img">
              <article className="video-item">
                <figure>
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/security-tp1.webp`}
                    alt=""
                    className="f7sec2img1"
                  />
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/yellow.svg`}
                    alt=""
                    className="overlay-image1"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                    alt=""
                    className="overlay-image2"
                  />
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                    alt=""
                    className="overlay-image3"
                  />
                </figure>
              </article>
            </div>

            <div className="col-lg-6 f7sec2content">
              <h3>Based on Microsoft Azure infrastructure</h3>
              <p>
                Our test creating software is based on reliable and proven
                solutions. To offer our customers maximum security, the
                infrastructure we use is based on Microsoft Azure.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="dark-bg">
        <div className="container-fluid dark-bg-sec">
          <div className="row f7sec3">
            <div className="col-lg-6 f7sec3head">
              <h4>Real-time protection </h4>
              <p>
                To build your online exams you just need a laptop with access to
                the Internet. No setup costs.
              </p>
              <div className="main-button">
                <div className="scroll-to-section">
                  <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
                </div>
              </div>
              <br />
              <p>No credit card required</p>
            </div>

            <div className="col-lg-6 f7sec3content">
              <ul>
                <li>
                  <h4>
                    <PiSquareLogoFill style={{ color: "#f5a425" }} /> Advanced
                    anti-DDoS techniques
                  </h4>
                </li>
                <li>
                  <h4>
                    <PiSquareLogoFill style={{ color: "#f5a425" }} />{" "}
                    Auto-scaling and redundancy
                  </h4>
                </li>
                <li>
                  <h4>
                    <PiSquareLogoFill style={{ color: "#f5a425" }} /> SSL & data
                    encryption
                  </h4>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="light-bg">
        <div className="container-fluid light-bg-sec">
          <div className="row f7sec4">
            <div className="col-md-12 col-lg-6 f7sec4img">
              <article className="video-item ">
                <figure>
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/custom-tp3.webp`}
                    alt=""
                  />
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_curve_top.svg`}
                    alt=""
                    className="green_curve_top"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_curve_bottom.svg`}
                    alt=""
                    className="green_curve_bottom"
                  />
                </figure>
              </article>
            </div>
            <div className="col-lg-6 f7sec4content">
              <h3>
                Your remote tests with the highest possible level of security
              </h3>
              <p>
                Reliable, insightful results and maximum security of online
                assessments are guaranteed by NexTestify.
              </p>
              <div className="main-button">
                <div className="scroll-to-section">
                  <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Links />
    </div>
  );
};

export default Feature7;
